<template>
  <div class="">
    <div class="label-standard">Year</div>

    <div class="form-line">
			<select
        :value="value"
        v-on:change="updateValue({
					objectType: objectType,
					objectId  : objectId,
					key       : propertyKey, 
					value     : $event.target.value,
					index     : index
        })"
        class="select-standard">
				<option value="? object:null ?"></option>
				<option value="-1" disabled="">Select an option...</option>
				<template v-for="(year, index) in years">
					<option :value="year">{{ year }}</option>
				</template>
			</select>
    </div>
  </div>
</template>

<script>
	import moment from 'moment'

  export default {

    props : {

      objectType : {
        type    : String,
        required: false
      },

      objectId : {
        type    : Number,
        required: false
      },

      value : {
        required: false
      },

      index : {
        type    : Number,
        required: false
      },

      propertyKey : {
        type    : String,
        required: false
      },

      updateValue : {
        type : Function,
        required : false
      },
    },

    computed : {
    	years() {
    		var list = [];
				for (var i = 1920; i <= moment().format('YYYY'); i++) {
    			list.push(i);
				}

				return list.reverse()
    	}
    }
  }
</script>